import { render, staticRenderFns } from "./IREquityProspectusPage.vue?vue&type=template&id=8a79cace"
import script from "./IREquityProspectusPage.vue?vue&type=script&lang=js"
export * from "./IREquityProspectusPage.vue?vue&type=script&lang=js"
import style0 from "./IREquityProspectusPage.vue?vue&type=style&index=0&id=8a79cace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports